import {Button, Modal} from 'react-bootstrap'
import {parseId, parsePrice} from '../../helpers'
import {useMutation} from '@apollo/client'
import {useEffect} from 'react'
import {toast} from 'react-toastify'
import {Spinner} from '../Spinner'
import {DELETE_ONE_PRICE} from '../../graphql/mutations/clientMutations'
import {IResDeletePrices} from '../../graphql/types/clientsTypes'

interface IInfoPriceDelete {
  price: string
  idPrice: string
  idProduct: string
  productName: string
  idClient: string
}

interface IModalProps {
  isOpen: boolean
  onClose: () => void
  onOpenPrices: () => void
  refetch: () => void
  info: IInfoPriceDelete
}

export const ModalDeletePrice: React.FC<IModalProps> = ({
  isOpen,
  onClose,
  info,
  onOpenPrices,
  refetch,
}) => {
  const [gqlDelete, {data, loading, error}] = useMutation<IResDeletePrices>(DELETE_ONE_PRICE)

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.productPriceClientDelete.success) {
      refetch()
      onClose()
      toast.success('Precio eliminado correctamente')
    } else if (data.productPriceClientDelete.errors) {
      toast.error(`Error: ${data.productPriceClientDelete.errors.message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDelete = () => {
    gqlDelete({
      variables: {
        input: {
          id: parseId(info.idPrice),
          productId: parseId(info.idProduct),
          clientId: parseId(info.idClient),
        },
      },
    })
  }

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Eliminar precio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h2 className='fs-2'>
          ¿Seguro que desea eliminar el precio{' '}
          <span className='text-info'>{parsePrice(info.price)}</span> del producto{' '}
          <span className='text-danger'>{info.productName}</span>?
        </h2>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='light'
          onClick={() => {
            onClose()
            onOpenPrices()
          }}
        >
          Cancelar
        </Button>
        <Button variant='danger' disabled={loading} onClick={handleDelete}>
          {loading && <Spinner color='light' size={12} />}
          Eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
